'use client';

import { useEffect, useRef } from 'react';

interface TermsOfUserContentProps {
  termsOfUse: string;
  title?: string;
}

export const TermsOfUserContent = ({
  termsOfUse,
  title = 'Termos de Uso',
}: TermsOfUserContentProps) => {
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hash) {
      const hash = window.location.hash.substring(1);
      const element = document.getElementById(hash);

      if (element && typeof element.scrollIntoView === 'function') {
        const timeoutId = setTimeout(() => {
          try {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch {
            window.scrollTo(0, element.offsetTop);
          }
        }, 100);

        return () => clearTimeout(timeoutId);
      }
    }
  }, []);

  return (
    <div className="flex flex-grow flex-col gap-4 p-2">
      <div
        ref={printRef}
        className="prose prose-sm max-w-none text-foreground/90 overflow-y-auto"
      >
        <h1 className="text-xl font-bold mb-4 text-foreground">{title}</h1>
        <div
          id="privacidade"
          className="text-sm leading-relaxed scroll-mt-4"
          dangerouslySetInnerHTML={{ __html: termsOfUse }}
        />
      </div>

      {/*<div className="text-xs text-foreground/60 border-t pt-3">*/}
      {/*  <p>*/}
      {/*    <strong>Data de impressão:</strong> {dayjs().format('DD/MM/YYYY HH:mm')}*/}
      {/*  </p>*/}
      {/*  <p className="mt-1">*/}
      {/*    Este documento foi gerado automaticamente e contém a versão mais atual da*/}
      {/*    política de privacidade.*/}
      {/*  </p>*/}
      {/*</div>*/}
    </div>
  );
};
